import { PAGE_NAMES } from '../../constants/tracking'
import { track } from '../../shared/tracking'
import { BoxOrderPlanModalTemplate } from '../../types/nextModal'

// Onboarding Modals
export const trackBoxSizePlanOfferModalShown = (
  data: BoxOrderPlanModalTemplate
) => {
  track('Overlay Viewed', {
    overlay_name: 'Box Size Plan Offer Modal',
    overlay_class: 'modal',
    overlay_source: 'custom',
    overlay_type: 'message',
    page_name: PAGE_NAMES.ORDERS,
    overlay_trigger: 'manual',
    user_plan_match_box_id: data.userPlanMatchBoxId,
    most_popular_box_id: data.mostPopularBoxId,
    user_match_plan_id: data.planId,
    boxes: data.boxes
  })
}

export const trackBoxSizePlanOfferModalClosed = (
  data: BoxOrderPlanModalTemplate
) => {
  track('Overlay Closed', {
    overlay_name: 'Box Size Plan Offer Modal',
    overlay_class: 'modal',
    overlay_source: 'custom',
    overlay_type: 'message',
    page_name: PAGE_NAMES.ORDERS,
    overlay_trigger: 'manual',
    user_plan_match_box_id: data.userPlanMatchBoxId,
    most_popular_box_id: data.mostPopularBoxId,
    user_match_plan_id: data.planId,
    boxes: data.boxes
  })
}

export const trackBoxSizePlanOfferModalClicked = (
  data: BoxOrderPlanModalTemplate
) => {
  track('CTA Button Clicked', {
    cta_text: 'Fill your box!',
    user_plan_match_box_id: data.userPlanMatchBoxId,
    most_popular_box_id: data.mostPopularBoxId,
    user_match_plan_id: data.planId,
    boxes: data.boxes
  })
}

// Box Size Plan Change Modal
export const trackBoxSizePlanChangeModalShown = () => {
  track('Overlay Viewed', {
    overlay_name: 'Box Size Plan Change Modal',
    overlay_class: 'modal',
    overlay_source: 'custom',
    overlay_type: 'message',
    page_name: PAGE_NAMES.ORDERS,
    overlay_trigger: 'manual'
  })
}

export const trackBoxSizePlanChangeModalClosed = () => {
  track('Overlay Closed', {
    overlay_name: 'Box Size Plan Change Modal',
    overlay_class: 'modal',
    overlay_source: 'custom',
    overlay_type: 'message',
    page_name: PAGE_NAMES.ORDERS,
    overlay_trigger: 'manual'
  })
}

// Plan and Box Change
export const trackBoxChange = (boxId: number) => {
  track('CTA Button Clicked', {
    cta_text: 'Change to Box',
    box_id: boxId
  })
}

export const trackPlanChange = (planId: number) => {
  track('CTA Button Clicked', {
    cta_text: 'Change to Plan',
    plan_id: planId
  })
}

export const trackMealCardBOMCoachmarkViewed = () => {
  track('Overlay Viewed', {
    overlay_name: 'Meal Card - BOM Coachmark',
    overlay_action: 'Meal Card - BOM Coachmark - Viewed'
  })
}
